import React, { useEffect, useContext, useState } from "react"
import _ from "lodash"
import { CommunityProjectContext } from "./context"
import { fetch_delete, fetch_get, fetch_patch, fetch_post, fetch_put } from "../../../utils/fetch"
import { sleep, isValidEmail } from "../../../utils/common"
import * as Sentry from "@sentry/gatsby"
import { useAuth0 } from "@auth0/auth0-react"
import { useUserOrgs } from "../../../hooks/use-user"
import Captcha from "../../../components/common/captcha"

function JoinProjectForm(props) {
  const {
    currentOrg: {
      role: { isSuperAdmin },
    },
  } = useUserOrgs()
  const { isAuthenticated, user } = useAuth0()
  let contextData = useContext(CommunityProjectContext)
  var [form, setForm] = useState({})
  var [formCopy, setFormCopy] = useState({})
  const [inputCode, setInputCode] = useState("")
  const [markercode, setMarkercode] = useState("")

  var [saveStatus, setSaveStatus] = useState({ loading: false, error: false, message: null })
  var [formValidationMessage, setFormValidationMessage] = useState(null)
  var [agreeToJoin, setAgreeToJoin] = useState(false)
  var [agreeToJoinCopy, setAgreeToJoinCopy] = useState(false)
  const { getAccessTokenSilently } = useAuth0()
  const clearForm = () => {
    return {
      firstName: "",
      lastName: "",
      email: "",
      username: "",
    }
  }

  const getMarkerCode = code => {
    // console.log("marker code is", code)
    setMarkercode(code)
  }
  const hande_change = e => {
    let temp = JSON.parse(JSON.stringify(form))
    temp[e.target.name] = e.target.type === "checkbox" ? e.target.checked : e.target.value
    setForm(temp)
  }

  const hande_change_agree_to_change = e => {
    setAgreeToJoin(e.target.checked)
  }

  const has_changes = () => {
    // console.log("has changes", JSON.stringify(form) !== JSON.stringify(formCopy))
    // console.log(JSON.stringify(form), JSON.stringify(formCopy))
    if (!isAuthenticated) return JSON.stringify(form) !== JSON.stringify(formCopy)
    else return agreeToJoinCopy !== agreeToJoin
  }

  const cancel_changes = () => {
    let temp = JSON.parse(JSON.stringify(clearForm()))
    setForm(temp)
    setFormCopy(temp)
  }

  const reset_form = () => {
    var obj = clearForm()
    setForm(obj)
    setFormCopy(obj)
    setFormValidationMessage(null)
  }

  const validate_form = () => {
    // console.log(inputCode, markercode)
    if (!isAuthenticated) {
      if (_.isEmpty(form.firstName)) return "Firstname is required"
      else if (_.isEmpty(form.lastName)) return "Lastname is required"
      else if (_.isEmpty(form.username)) return "Username is required"
      else if (_.isEmpty(form.email)) return "Email is required"
      else if (!isValidEmail(form.email)) return "Email should be valid"
      else if (inputCode !== markercode) return "Incorrect captch code entered"
    }
    if (!agreeToJoin) return "Please accept to join the project"
    return null
  }

  const handleWelcomEmail = userdata => {
    setSaveStatus({
      loading: true,
      error: null,
      message: "Sending welcome mail....",
    })
    fetch_get(`users/${form.username}/send_welcome`)
      .then(response => {
        setSaveStatus({
          loading: false,
          error: null,
          message: "Email Sent Successfully",
        })
        contextData.setSuccessData(userdata)
      })
      .catch(error => {
        setSaveStatus({ loading: false, error: true, message: `${error}` })
        Sentry.captureException(error)
        console.log(`Error while adding project link to project: ${error}`)
      })
  }
  const add_user_and_then_addtoproject = () => {
    setSaveStatus({ loading: true, error: null, message: "Saving the changes" })

    if (!isAuthenticated) {
      fetch_post(`users/project/${props.project.projectId}/contributor`, form)
        .then(response => {
          if (response.status.code === 201) {
            setSaveStatus({
              loading: true,
              error: response.status.error,
              message: response.status.description,
            })
            handleWelcomEmail(response.data)
          }
        })
        .catch(error => {
          setSaveStatus({ loading: false, error: true, message: `${error}` })
          console.log(form)
          Sentry.captureException(error)
          console.log(`Error while creating new account as contributor: ${error}`)
        })
    } else {
      getAccessTokenSilently()
        .then(accessToken =>
          fetch_patch(`users/project/${props.project.projectId}/contributor`, form, accessToken)
            .then(response => {
              if (response.status.code === 201) {
                setSaveStatus({
                  loading: false,
                  error: response.status.error,
                  message: response.status.description,
                })
                contextData.setSuccessData(response.data)
                contextData.setIsNowContributor(true)
              }
            })
            .catch(error => {
              setSaveStatus({ loading: false, error: true, message: `${error}` })
              console.log(form)
              Sentry.captureException(error)
              console.log(`Error while adding user to the project: ${error}`)
            })
        )
        .catch(error => {
          setSaveStatus({ loading: false, error: true, message: `${error}` })
          Sentry.captureException(error)
          console.log(`Error while getting access token: ${error}`)
          console.log(form)
        })
    }
  }

  const save_changes = async () => {
    var valres = validate_form()
    setFormValidationMessage(valres)
    if (valres === null) {
      add_user_and_then_addtoproject()
    }
  }

  useEffect(() => {
    reset_form()
  }, [])

  useEffect(() => {
    if (form === undefined || form === null) return
    if (form.firstName === undefined || form.firstName === null) return
    if (form.lastName === undefined || form.lastName === null) return
    let temp = JSON.parse(JSON.stringify(form))
    if ((!isAuthenticated && temp.firstName.length > 0) || temp.lastName.length > 0) {
      temp.username = `${temp.firstName.toLowerCase()}.${temp.lastName.toLowerCase()}`
      setForm(temp)
    }
  }, [form.firstName, form.lastName, isAuthenticated])

  return (
    <React.Fragment>
      {contextData.successData !== null && (
        <>
          {!isAuthenticated && (
            <>
              <div className="alert alert-success" role="alert">
                Hello{" "}
                <strong>
                  {form.firstName} {form.lastName}
                </strong>
                , <br />
                <br />
                We have sent you a “Welcome” email. Please check your inbox and follow the
                instructions to complete your account setup. Once you log into your account through
                the website, you will see your list of projects to which you can follow and
                contribute.
                <br />
                <br />
                <p>Thank you and welcome to the CodeLinaro Community!</p>
              </div>
            </>
          )}
          {isAuthenticated && (
            <>
              <div className="alert alert-success" role="alert">
                Thanks for joining this project
              </div>
            </>
          )}
        </>
      )}
      {contextData.successData === null && (
        <>
          <table className="table table-sm" style={{ "margin-bottom": "30px" }}>
            <thead>
              <tr>
                <th scope="col" colSpan={2}>
                  Project Details
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th scope="row">Name</th>
                <td>{props.project.name}</td>
              </tr>
            </tbody>
          </table>
          {!isAuthenticated && (
            <>
              <div style={{ "margin-bottom": "30px" }}>
                <div className="card border-success">
                  {/* <div className="card-header">
                <h3>CodeLinaro Users</h3>
              </div> */}
                  <div className="card-body">
                    <p>If you have a CodeLinaro User Account, please login</p>
                    <p>
                      <a className="btn mr-2 btnBgColor" href="/dashboard/">
                        Login
                      </a>
                    </p>
                  </div>
                </div>
              </div>

              <div className="card border-success mb-3">
                <div className="card-header">Create New Account</div>
                <div className="card-body">
                  <div className="form-group">
                    <label>First Name</label>
                    <input
                      type="text"
                      name="firstName"
                      onChange={e => hande_change(e)}
                      value={form.firstName || ""}
                      className="form-control"
                      placeholder="First Name"
                    />
                  </div>
                  <div className="form-group">
                    <label>Last Name</label>
                    <input
                      type="text"
                      name="lastName"
                      onChange={e => hande_change(e)}
                      value={form.lastName || ""}
                      className="form-control"
                      placeholder="Last Name"
                    />
                  </div>
                  <div className="form-group">
                    <label>Username</label>
                    <input
                      type="text"
                      name="username"
                      onChange={e => hande_change(e)}
                      value={form.username || ""}
                      className="form-control"
                      placeholder="Username"
                    />
                  </div>
                  <div className="form-group">
                    <label>Email</label>
                    <input
                      type="text"
                      name="email"
                      onChange={e => hande_change(e)}
                      value={form.email || ""}
                      className="form-control"
                      placeholder="Email"
                    />
                  </div>
                  <div className="form-group">
                    <label for="inputCity" className="form-label">
                      Captcha:
                    </label>
                    <form className="row">
                      <div className="col-6">
                        <input
                          type="text"
                          name="inputCode"
                          id="inputCode"
                          value={inputCode}
                          onChange={event => setInputCode(event.target.value)}
                        />
                      </div>

                      <div className="col-2">
                        <Captcha onChange={getMarkerCode}></Captcha>
                      </div>
                    </form>
                  </div>
                  <div className="form-group">
                    <input
                      type="checkbox"
                      placeholder="Your name"
                      id="agreeToJoin"
                      name="agreeToJoin"
                      onChange={e => hande_change_agree_to_change(e)}
                      aria-describedby="emailHelp"
                      value={agreeToJoin}
                    />{" "}
                    <span id="isFaireUseConsidered_label" className="form-label">
                      I wish to join or follow this project: “{props.project.name}” (
                      {props.project.parentOrganization} /{props.project.projectSlug})
                    </span>
                  </div>
                  <button
                    type="button"
                    onClick={() => save_changes()}
                    disabled={!has_changes()}
                    className="btn btn-primary"
                  >
                    Submit
                  </button>
                  &nbsp;
                  <button
                    type="button"
                    onClick={() => reset_form()}
                    disabled={!has_changes()}
                    className="btn btn-info"
                  >
                    Reset
                  </button>{" "}
                  &nbsp;
                  {formValidationMessage !== null && (
                    <div className="form-group">
                      <span className="text-danger" role="alert">
                        <strong>{formValidationMessage}</strong>
                      </span>
                    </div>
                  )}
                  {saveStatus !== null && (
                    <>
                      <div className="form-group">
                        {saveStatus.loading && (
                          <>
                            <div className="spinner-grow spinner-grow-sm" role="status"></div>
                          </>
                        )}

                        {saveStatus.error && (
                          <span className="text-danger" role="alert">
                            <strong>{saveStatus.message}</strong>
                          </span>
                        )}

                        {!saveStatus.error && (
                          <span className="text-success" role="alert">
                            <strong>{saveStatus.message}</strong>
                          </span>
                        )}
                      </div>
                    </>
                  )}
                </div>
              </div>
            </>
          )}
          {isAuthenticated && (
            <>
              <div className="form-group">
                <input
                  type="checkbox"
                  placeholder="Your name"
                  id="agreeToJoin"
                  name="agreeToJoin"
                  onChange={e => hande_change_agree_to_change(e)}
                  aria-describedby="emailHelp"
                  value={agreeToJoin || false}
                />{" "}
                <span id="isFaireUseConsidered_label" className="form-label">
                  I wish to join or follow this project: “{props.project.name}” (
                  {props.project.parentOrganization} /{props.project.projectSlug})
                </span>
              </div>
              <button
                type="button"
                onClick={() => save_changes()}
                disabled={!has_changes()}
                className="btn btn-primary"
              >
                Submit
              </button>
              &nbsp;
              {formValidationMessage !== null && (
                <div className="form-group">
                  <span className="text-danger" role="alert">
                    <strong>{formValidationMessage}</strong>
                  </span>
                </div>
              )}
              {saveStatus !== null && (
                <>
                  {saveStatus.loading && (
                    <>
                      <div className="spinner-grow spinner-grow-sm" role="status"></div>...
                    </>
                  )}
                  <div className="form-group">
                    {saveStatus.error && (
                      <span className="text-danger" role="alert">
                        <strong>{saveStatus.message}</strong>
                      </span>
                    )}

                    {!saveStatus.error && (
                      <span className="text-success" role="alert">
                        <strong>{saveStatus.message}</strong>
                      </span>
                    )}
                  </div>
                </>
              )}
            </>
          )}
        </>
      )}
    </React.Fragment>
  )
}

export default JoinProjectForm
